import { render } from "./MenuLayout.vue?vue&type=template&id=7577fe56&scoped=true"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"

import "./MenuLayout.vue?vue&type=style&index=0&id=7577fe56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7577fe56"]])

export default __exports__